<template>
  <div>
    <header class="Header">
      <div class="Header__inner">
        <div class="Header_menu__logo">
          <img class="Header_menu__logo_img" src="assets/img/melon_logo_blue.png" alt="MELON ONLINE">
        </div>
      </div>
    </header>
    <div v-if="!showSent" class="contents contents--pt">
      <section class="Form _min-h">
        <div class="inner">
          <div class="Form--pt">
            <p class="Form__tx Form__tx--md">
              パスワード再設定用のメールをお送りいたしますので、<br class="_dsp-none--sp">ご登録のメールアドレスをご入力ください。
            </p>
            <div :class="`Form__input_box Form__input_box--xlg ${$v.form.email.$error ? '_error' : ''}`">
              <input
                v-model.trim="$v.form.email.$model"
                class="Form__input Form__input--mt_md"
                placeholder="sample@gmail.com"
                type="text"
              >
              <label class="Form__error_tx">{{ errors.email }}</label>
              <div class="Form__error_box">
                <div class="Form__error_tx">
                  <label v-if="!$v.form.email.required" class="Form__error_tx">メールが必要です</label>
                  <label v-if="!$v.form.email.email" class="Form__error_tx">正しいメールアドレスを入力してください。</label>
                  <label v-if="!$v.form.email.maxLength" class="Form__error_tx">メールの最大長255</label>
                </div>
              </div>
            </div>
            <button :disabled="$v.form.$invalid" class="Btn__blue Form__btn--mt_md" @click="sendEmail">
              メールを送信
            </button>
          </div>
        </div>
      </section>
    </div>
    <div v-else class="contents contents--pt">
      <section class="Form _min-h">
        <div class="inner">
          <div class="Form--pt">
            <p class="Form__tx">
              パスワード再設定用のメールを送付いたしました。<br>
              メールに記載された再設定用URLをクリックして、<br class="_dsp-none--sp">
              お手続きを進めてください。
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { email, required, maxLength } from 'vuelidate/lib/validators'
import authService from '@/services/authService'
// import message from '@/helpers/message'

export default {
  name: 'ForgotPasswordForm',
  mixins: [validationMixin],
  data() {
    return {
      showSent: false,
      form: {
        email: ''
      },
      errors: {
        email: ''
      }
    }
  },
  validations: {
    form: {
      email: {
        required,
        email,
        maxLength: maxLength(255)
      }
    }
  },
  methods: {
    sendEmail() {
      this.$store.dispatch('loading/updateLoading', true)
      authService.forgotPassword(this.form.email).then(() => {
        this.$store.dispatch('loading/updateLoading', false)
        this.showSent = true
      }).catch(() => {
        this.errors.email = 'メールがシステムに存在しません'
        this.$store.dispatch('loading/updateLoading', false)
      })
    }
  }
}
</script>
